<script setup lang="ts">
import { onBeforeMount } from 'vue'

import { tollRoadModel, TollRoadsEnrollPage } from '@/pages/tollroads_enroll_page'

import { DefaultLayout } from '../../layouts'

const { getCsrf } = tollRoadModel.useModel()

onBeforeMount(async () => {
    await getCsrf()
})
</script>

<template>
    <DefaultLayout><TollRoadsEnrollPage /></DefaultLayout>
</template>
